var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIconCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66663 12.0329C5.66663 14.933 7.77295 17.3446 10.5277 17.8337V13.6205H9.0694V12.0003H10.5277V10.7039C10.5277 9.24553 11.4674 8.43567 12.7964 8.43567C13.2174 8.43567 13.6714 8.50033 14.0924 8.56498V10.0559H13.3472C12.6341 10.0559 12.4722 10.4122 12.4722 10.8662V12.0003H14.0277L13.7686 13.6205H12.4722V17.8337C15.227 17.3446 17.3333 14.9335 17.3333 12.0329C17.3333 8.80658 14.7083 6.16699 11.5 6.16699C8.29163 6.16699 5.66663 8.80658 5.66663 12.0329Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIconCircle);
export default __webpack_public_path__ + "static/media/fb-icon-circle.c25f10973d9053d4376e835ad99298b6.svg";
export { ForwardRef as ReactComponent };